// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import createSearchParams from '../../helpers/createSearchParams'
import generateSearchQuery from '../../helpers/generateSearchQuery'
import generateReportQuery from '../../helpers/generateReportQuery'
import downloadReportQuery from '../../helpers/downloadReportQuery'
import downloadCustomReportQuery from '../../helpers/downloadCustomReportQuery'
import downloadSpecialReportQuery from '../../helpers/downloadSpecialReportQuery'

import { reportPermissions, accountPermissions } from '../../helpers/permissions'

const { axiosIns } = useJwt
// const baseUrl = 'https://sandbox-reporting.udara360.io/api'

export default {
  getOverdraftReport: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/overdraftReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.OVERDRAFT_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTransactionReports: async (
    context,
    {
      search, page = 1, limit = 10, route, permission, type = '', entryCodes,
    },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: `TransactionReports/v1/${route}`,
      currentPage: page,
      perPage: limit,
    })
    let codes
    if (entryCodes) {
      codes = entryCodes.map(item => `entryCodes=${item}`).join('&')
    }

    const transactionURL = type === 'entryCode' ? `${url}&${codes}` : url
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/${transactionURL}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadTransactionReports: async (
    context,
    {
      search, page = 1, limit = 10, route, permission,
    },
  ) => {
    const url = generateReportQuery({
      filter: search,
      url: `TransactionReports/v1/${route}`,
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getEODTransactionReports: async (
    context,
    {
      search, page = 1, limit = 10, route, permission,
    },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: `TransactionReports/v1/${route}`,
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountBalances: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/customerAccountBalanceReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.ACCOUNT_BALANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanAdvances: async (context, { search, page = 1, limit = 20 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/loansAndAdvances',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.LOAN_AND_ADVANCES_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanAdvances: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/LoanReports/v1/exportLoansAndAdvancesV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanCollections: async (
    context,
    {
      search, page = 1, limit = 20, fileExportFormat,
    },
  ) => {
    const url = generateReportQuery({
      filter: search,
      url: 'LoanReports/v1/exportLoansCollections',
      currentPage: page,
      perPage: limit,
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(reportPermissions.EXPORT_LOAN_COLLECTIONS_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`, {
        responseType: 'blob',
      })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanTrackingReport: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/loanTracking',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.LOAN_TRACKING_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanTrackingReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/LoanReports/v1/exportloanTracking',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getClosedLoanReport: async (
    context,
    {
      search, page = 1, limit = 10, permission,
    },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/closedLoans',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getEChannelTransactionReport: async (
    context,
    {
      search, page = 1, limit = 10, permission,
    },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'TransactionReports/v1/echannelsReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getActiveAccountReport: async (context, { search, page, limit }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/activeAccountsReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.VIEW_ACTIVE_ACCOUNTS_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getAccountBalanceMovement: async (context, { search, page, limit }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/accountBalanceMovementReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.ACCOUNT_BALANCE_MOVEMENT_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanCollections: async (context, { search, page, limit }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/loanCollections',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.LOAN_COLLECTIONS_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getDepositBalance: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/depositBalanceReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.DEPOSITS_BALANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadDepositBalanceReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/CustomerAccountReports/v1/exportDepositBalanceReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getVatWHTReports: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'TransactionReports/v1/getVATandWHTReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.VAT_AND_WHT_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFixedDepositBalance: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/fixedDepositBalanceReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.FIXED_DEPOSITS_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBVNNINComplianceReport: async (
    context,
    { search, page = 1, limit = 10 },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'RegulatoryReports/v1/complianceReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.VIEW_COMPLIANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getDailyTillBalance: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'TransactionReports/v1/getDailyTillBalanceReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.DAILY_TILL_BALANCE_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSavingsAccrualHistory: async (
    context,
    { search, page = 1, limit = 10 },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/savingsAccrualReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.SAVINGS_ACCRUAL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanAccrualHistory: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/loanAccrualReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.LOAN_ACCRUAL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getFDAccrualHistory: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/fdAccrualReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(
        reportPermissions.FIXED_DEPOSIT_ACCRUAL_HISTORY_REPORT,
      )
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getOverdraftAccrualHistory: async (
    context,
    { search, page = 1, limit = 10 },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/odAccrualReportAsync',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.OVERDRAFT_ACCRUAL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGLHistories: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'TransactionReports/v1/glHistoryReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.GL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getGLBalanceHistories: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'TransactionReports/v1/glStatement',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.GL_HISTORY_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getLoanRepaymentExpectation: async (
    context,
    { search, page = 1, limit = 10 },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/loanExpectation',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.LOAN_REPAYMENT_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getDisbursedLoansReports: async (
    context,
    { search, page = 1, limit = 10 },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'LoanReports/v1/disbursedLoans',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.DISBURSED_LOAN_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getChartOfAccount: async () => {
    try {
      useJwt.setPermission(reportPermissions.VIEW_CHART_OF_ACCOUNT_REPORT)
      const response = await axiosIns.get(
        '/reporting/api/FinancialReports/v1/chartofaccount',
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getTrialBalance: async (context, formData) => {
    try {
      useJwt.setPermission(reportPermissions.VIEW_TRIAL_BALANCE_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/FinancialReports/v1/trialbalance?FinancialDate=${formData.financialDate}&BranchCode=${formData.branchCode}&Level=${formData.level}&IsCurrentFinancialDate=${formData.isCurrentFinancialDate}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadTrialBalanceReport: async (context, formData) => {
    try {
      const searchParams = createSearchParams(formData)
      useJwt.setPermission(reportPermissions.EXPORT_TRIAL_BALANCE_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/FinancialReports/v1/exportTrialBalanceReport?${searchParams}`,
        { responseType: 'blob' },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadNDICReport: async (context, formData) => {
    try {
      useJwt.setPermission(reportPermissions.EXPORT_NDIC_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/NdicReport/v1/getNdicReportV2?ReportingDate=${formData.reportingDate}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadCBNReport: async (context, formData) => {
    try {
      useJwt.setPermission(reportPermissions.EXPORT_CBN_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/CBNReport/v1/getCBNReportV2?ReportingDate=${formData.reportingDate}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadThreeTieredKYCReport: async (context, { startDate, endDate }) => {
    try {
      useJwt.setPermission(reportPermissions.THREE_TIERED_KYC_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/TierAccountsReport/v1/exportTierAccountsReport?StartDate=${startDate}&EndDate=${endDate}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadActiveAccountReport: async (context, formData) => {
    const searchParams = createSearchParams(formData)
    try {
      useJwt.setPermission(reportPermissions.EXPORT_ACTIVE_ACCOUNTS_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/CustomerAccountReports/v1/exportActiveAccountReport?${searchParams}`,
        { responseType: 'blob' },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadEchannelReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/TransactionReports/v1/ExportEchannelsReportV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBalanceSheetReport: async (context, formData) => {
    const searchParams = createSearchParams(formData)
    try {
      useJwt.setPermission(reportPermissions.VIEW_BALANCE_SHEET_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/FinancialReports/v1/balanceSheetReport?${searchParams}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadBalanceSheetReport: async (context, formData) => {
    try {
      const searchParams = createSearchParams(formData)
      useJwt.setPermission(reportPermissions.EXPORT_BALANCE_SHEET_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/FinancialReports/v1/exportBalanceSheetReport?${searchParams}`,
        { responseType: 'blob' },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadProfitAndLossReport: async (context, formData) => {
    try {
      const searchParams = createSearchParams(formData)
      useJwt.setPermission(reportPermissions.EXPORT_PROFIT_OR_LOSS_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/FinancialReports/v1/exportprofitOrLossReport?${searchParams}`,
        { responseType: 'blob' },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getProfitOrLoss: async (context, formData) => {
    const searchParams = createSearchParams(formData)
    try {
      useJwt.setPermission(reportPermissions.VIEW_PROFIT_OR_LOSS_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/FinancialReports/v1/profitOrLossReport?${searchParams}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getPeriodicTrialBalance: async (context, formData) => {
    try {
      useJwt.setPermission(reportPermissions.VIEW_TRIAL_BALANCE_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/FinancialReports/v1/periodictrialbalance?StartDate=${formData.startDate}&EndDate=${formData.endDate}&BranchCode=${formData.branchCode}&Level=${formData.level}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCustomerAccountStatement: async (context, formData) => {
    try {
      useJwt.setPermission(accountPermissions.ACCOUNT_STATEMENT)
      const response = await axiosIns.get(
        `/reporting/api/CustomerStatement/v1/generateStatement?FinancialDateFrom=${formData.financialDateFrom}&FinancialDateTo=${formData.financialDateTo}&AccountNumber=${formData.accountNumber}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadCustomerAccountStatementReport: async (context, formData) => {
    try {
      const searchParams = createSearchParams(formData)
      useJwt.setPermission(accountPermissions.ACCOUNT_STATEMENT)
      const response = await axiosIns.get(
        `/reporting/api/CustomerStatement/v1/exportCustomerStatement?${searchParams}`,
        { responseType: 'blob' },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getICADReport: async (context, { search, page, limit }) => {
    try {
      useJwt.setPermission(reportPermissions.ICAD_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/RegulatoryReports/v1/icadReport?StartDate=${search.startDate}&EndDate=${search.endDate}&PageNumber=${page}&PageSize=${limit}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getMarketPerformanceReport: async (context, {
    search, page, limit, permission,
  }) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/reporting/api/MarketerPerformanceReport/v1/getMarketerPerformanceReport?StartDate=${search.startDate}&EndDate=${search.endDate}&PageNumber=${page}&PageSize=${limit}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadICADReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/RegulatoryReports/v1/exporticadReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadMarketerPerformanceReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadSpecialReportQuery({
      filter: search,
      url: '/reporting/api/MarketerPerformanceReport/v1/exportMarketerPerformanceReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getCreditBrueau: async (context, formData) => {
    try {
      useJwt.setPermission(reportPermissions.EXPORT_CREDIT_BUREAU_REPORT)
      const response = await axiosIns.get(
        `/reporting/api/RegulatoryReports/v1/exportCreditBureauV2?ReportingDate=${formData.reportingDate}&PeriodTogenerateHistoryInMonths=${formData.period}`,
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getNFIUReport: async (context, { search, page = 1, limit = 10 }) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'RegulatoryReports/v1/nfiuReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.NFIU_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadAMLReports: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/RegulatoryReports/v1/ExportAMLReportV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadDisbursedLoanReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/LoanReports/v1/ExportDisbursedLoansReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadFixedAssetRegisterReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/FixedAssetRegister/v1/exportFixedAssetRegister',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadGLBalanceHistoryReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/TransactionReports/v1/ExportGlStatement',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadGLHistoryReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/TransactionReports/v1/ExportGlHistoryReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadEChannelTransactionReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/tpcard/api/Report/v1/ExportTransaction',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadISOCardTransactionReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/card/api/TransactionReport/v1/ExportISOTransactionReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanProvisioningReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/LoanReports/v1/ExportLoanProvisionV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadOverdraftProvisioningReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/LoanReports/v1/ExportOverdraftProvisionV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getNewlyCreatedAccountReport: async (
    context,
    { search, page = 1, limit = 10 },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: 'CustomerAccountReports/v1/accountCreationReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(reportPermissions.ACCOUNT_CREATION_REPORT)
      const response = await axiosIns.get(`/reporting/api/${url}`)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getSuspiciousTransactionReports: async (
    context,
    {
      search, page, limit = 10, permission,
    },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/reporting/api/TransactionReports/v1/SearchSuspiciousTransactions',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getBatchUploadTracer: async (
    context,
    {
      search, page, limit = 10, permission,
    },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/reporting/api/TransactionReports/v1/SearchBatchJobsReport',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanApplicationLetter: async (
    context,
    { partnerCode, permission, route },
  ) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/reporting/api/LMS/v1/${route}?PartnerCode=${partnerCode}`,
        { responseType: 'blob' },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadKYCDocumentFiles: async (
    context,
    { partnerCode, permission, route },
  ) => {
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(
        `/reporting/api/LMS/v1/${route}?PartnerCode=${partnerCode}`,
        { responseType: 'blob' },
      )
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadSMSReports: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/SMSReport/v1/exportSmsReportV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadEmailReport: async (
    context,
    {
      search, page, limit, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      currentPage: page,
      perPage: limit,
      url: '/reporting/api/EmailReport/v1/exportEmailReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadODAccrualReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/CustomerAccountReports/v1/ExportODAccrualReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadSavingsAccrualReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/CustomerAccountReports/v1/ExportSavingsAccrualReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadLoanAccrualReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/CustomerAccountReports/v1/ExportLoanAccrualReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadFixedDepositAccrualReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/CustomerAccountReports/v1/ExportFDAccrualReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadNewlyCreatedAccounts: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/CustomerAccountReports/v1/ExportAccountCreationReportV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadComplianceReports: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/RegulatoryReports/v1/ExportComplianceReportV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  getDownlaodHistoryReport: async (
    context,
    {
      search, page, limit = 10, permission,
    },
  ) => {
    const url = generateSearchQuery({
      filter: search,
      url: '/reporting/api/Operations/v1/reportDownloadHistory',
      currentPage: page,
      perPage: limit,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  downloadTransactionCallOversReports: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/TransactionReports/v1/ExportTransactionCallOverReportV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadCustomerAccountBalanceHistoryReports: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/TransactionReports/v1/ExportCustomerHistoryReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url, {
        responseType: 'blob',
      })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadAccountBalanceMovementReports: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/CustomerAccountReports/v1/exportAccountBalanceMovementReportV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadCustomerAccountBalanceReports: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadReportQuery({
      filter: search,
      url: '/reporting/api/CustomerAccountReports/v1/ExportCustomerAccountBalanceReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url, {
        responseType: 'blob',
      })
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadPEPReports: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/PEPTransactionReport/v1/exportPEPTransactionReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadAuditTrailReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/Operations/v1/ExportAuditTrailV2',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadEODTransactionReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/reporting/api/TransactionReports/v1/ExportEodTransactionReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.post(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadHostFinacialInstitutionReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/card/api/HostFI/v1/ExportHostFIReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadCardProfileReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/card/api/CardProfile/v1/ExportCardProfileReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadCardRequestLogReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/card/api/CardGeneration/v1/ExportCustomerCardRequestReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
  downloadCardGenerationReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/card/api/CardGeneration/v1/ExportCardGenerationReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },

  downloadCardsReport: async (
    context,
    {
      search, permission, fileExportFormat,
    },
  ) => {
    const url = downloadCustomReportQuery({
      filter: search,
      url: '/card/api/Card/v1/ExportCardReport',
      exportFormat: fileExportFormat,
    })
    try {
      useJwt.setPermission(permission)
      const response = await axiosIns.get(url)
      return Promise.resolve(response)
    } catch (error) {
      return Promise.reject(error)
    }
  },
}
